<ion-accordion-group>
  <ion-accordion value="map">
    <ion-item slot="header" (click)="updateMap()">
      <h3>Karte</h3>
    </ion-item>
    <div slot="content">
      <div class="map"
           leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event);">
      </div>
    </div>
  </ion-accordion>
</ion-accordion-group>

